import React from "react";
import { Link } from "react-router-dom";
import "../css/privacy.scss";

export const POLICY_UPDATED = "October 16, 2026";
export const SUPPORT_EMAIL = "wares@tuddlepetgoods.club";

export function SupportEmail() {
  return <a href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>;
}

function PolicyPage({ title, children, showUpdated = true }) {
  return (
    <main className="main-content" id="MainContent">
      <div className="policy__container">
        <div className="policy__title">
          <h1>{title}</h1>
        </div>
        <div className="policy__body">
          <div className="rte">
            {showUpdated && <p>Last updated: {POLICY_UPDATED}</p>}
            {children}
            <p className="policy__related">
              <strong>Related policies</strong>
              <br />
              Visit the <Link to="/policies">Policy Center</Link> to review all
              Tuddlepetgoods store policies.
            </p>
          </div>
        </div>
      </div>
    </main>
  );
}

export default PolicyPage;
